<template>
    <div v-if="question.isShow" class="question-item">
        <!--<div class="question-title"><i v-if="question.isMust">*</i>{{question.title}}</div>-->
        <div class="question-title"><i v-if="question.isMust">*</i>{{question.serialNumber}}.{{question.title}}</div>
        <div  v-if="question.note">说明：{{question.note}}</div>
        <img class="qs-img-preview" :src="question.pictureUrl" alt="">

        <div class="question-option">
            <span class="completionText">{{question.completeConfig.completeTextArr[0].text1}}</span>
            <input v-model="question.value" :type="question.completeConfig.completeType">
            <span class="completionText">{{question.completeConfig.completeTextArr[0].text2}}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'questionCompletion',
    props: {
      question: { required: true },
      patientId: { required: false },
    },
    mounted() {
      this.getPicture()
    },
    methods: {
      selectHandler (item) {
        this.question.options.forEach(v => {
          v.selected = false
        })
        item.selected = true
        this.question.value = item
      },
      checkIsFill () {
        if(this.question.isShow) {
          if (this.question.isMust) {
            if (this.question.value) {
              return true
            } else {
              return false
            }
          }else {
            return true
          }
        }else {
          return true
        }

      },
      getPicture() {
        if(this.question.pictureUrl) {
          this.$store.dispatch('getPicture', {url:[this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
        }
      },
      saveAnswer () {
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: this.question.value || null,
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId || null,
          questionType: this.question.type||null,
        }
          if (this.$route.query.abnormal=='5') {
              params.isRecord  = true
            }else {
              params.isRecord  = false
            }
        if(this.question.answerInfo) {
          this.$store.dispatch('updateQuestionAnswer', params)
        }else {
          this.$store.dispatch('saveQuestionAnswer', params)
        }
        // this.$store.dispatch('saveQuestionAnswer',)
      },
    }
  }
</script>

<style lang="scss" scoped>
    @import "questionCommon";

    .question-option {
        display: flex;

        .option-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            span {
                font-size: 16px;
                margin-left: 10px;
            }
        }

        .option-other {

        }
    }


</style>